<ng-container *ngIf="isReady$ | async; else loadingTmpl">
  <rd-core-main-container #container>
    <star-bypass-block bypass-block></star-bypass-block>
    <star-core-header
      main-header
      role="header"
      aria-label="site header"
      tabindex="-1"
      [authRenderState]="container.authRenderState$ | async"
      [pointsSummary]="container.pointsSummary$ | async"></star-core-header>
    <star-core-main-footer main-footer></star-core-main-footer>
  </rd-core-main-container>
</ng-container>

<ng-template #loadingTmpl>
  <div class="flex h-screen w-screen items-center justify-center">
    <rd-shared-spinner></rd-shared-spinner>
  </div>
</ng-template>
